import React, { FC, useEffect } from "react";
import { Container } from "../../../../symphony";
import { SlLEContext } from "../../global-constants";
import { SlEventsService } from "../../services/Business/sl-events.service";

export const LessonCompletePaywall = () => {

	const { onLessonCompletePaywallInit } = Container.take(SlLEContext, SlEventsService);
	useEffect(onLessonCompletePaywallInit, []);
	return <div>Lesson Complete Paywall</div>;
};